import React, { FC, useContext } from 'react';

import { useMe } from './useMe';
import type { UseMeValueType, MeType } from './useMe';

const UserContext = React.createContext<UseMeValueType>({
  isInited: false,
  isOrgSynced: true,
  currentOrg: null,
  data: { me: {} as MeType },
  can: () => false,
  onOrgChange: () => void 0,
  refetch: () => void 0,
});

export const useUserContext = () => useContext<UseMeValueType>(UserContext);

const UserContextProviderComponent: FC = ({ children }) => {
  const value = useMe();

  return <UserContext.Provider value={value as UseMeValueType}>{children}</UserContext.Provider>;
};

export const UserContextProvider = React.memo(
  UserContextProviderComponent,
) as typeof UserContextProviderComponent;
